module.exports = __webpack_public_path__ + "static/media/delineBanner.49db8b9c.png";